export const MAIL_SETTINGS = {
	INACTIVITY: 'inactivityMailNotification',
};

export const PUSH_SETTINGS = {
	INACTIVITY: 'inactivityPushNotification',
	SALES: 'salesPushNotification',
};

export const allSettingsKeys = ((settings) => {
	return settings
		.map((settingCluster: Object) => Object.keys(settingCluster).map((clusterKey) => settingCluster[clusterKey]))
		.reduce((previousValue, currentValue) => currentValue.concat(previousValue));
})([MAIL_SETTINGS, PUSH_SETTINGS]);
